// extracted by css-extract-rspack-plugin
export default {"wrapper":"TextmarkPicker_wrapper__wE9Xc","secondaryItemLabel":"TextmarkPicker_secondaryItemLabel__e4KaK","treeWrapper":"TextmarkPicker_treeWrapper__gAF4-"};